import { useQuery } from '@tanstack/react-query';

import { axios } from '../../../libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '../../../libraries/react-query';
import { DryRunUserDataDeletion } from '../types';

export const dryRunUserDataDeletion: DryRunUserDataDeletion = (params) => {
  return axios.post('/meta/user-data-deletion/dry-run', params);
};

type UseDryRunUserDataDeletionOptions = {
  chatIds: string[];
  config?: QueryConfig<DryRunUserDataDeletion>;
};

export function useDryRunUserDataDeletion({ config, chatIds }: UseDryRunUserDataDeletionOptions) {
  return useQuery<ExtractFnReturnType<DryRunUserDataDeletion>>({
    ...config,
    queryKey: ['dryRunUserDataDeletion', chatIds],
    queryFn: () => dryRunUserDataDeletion({ chatIds }),
    enabled: false,
  });
}
